export default "__VITE_ASSET__buWvyGEk__"